<template>
  <div class="ad-container" :style="bannerImageStyle"></div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "AdBanner",
  props: {
    siteID: Number
  },
  data() {
    return {
      bannerImageStyle:
        "background-image: url(" +
        this.$contentApiUrl +
        "/Image/BannerAd)"
    };
  }
};
</script>
<!-- Styles -->
<style scoped>
div.ad-container {
  width: 100%;
  height: 80px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0px;
  left: 0px;
}
</style>